import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Fusion clsx + tailwind-merge pour composants style shadcn */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
